"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PillSelection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _base = require("@site/pattern-library-utils/base.functions");
var _density = require("@site/pattern-library-utils/density");
var _precheckIcons = require("../utils/precheck-icons");
var _pillSelectionItem = _interopRequireDefault(require("./pill-selection-item"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PillSelectionContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PillSelectionContainer",
  class: "pc-p12v3wbr",
  vars: {
    "p12v3wbr-1": [({
      split
    }) => split ? 2 : 1]
  }
});
function PillSelection({
  id,
  items = [],
  ariaLabel,
  split = false,
  selected,
  setSelected,
  onChange,
  partial
}) {
  const radioRef = (0, _react.useRef)();
  const optionSelectionHandler = (0, _react.useCallback)(({
    target
  }) => {
    if (target.role !== 'radio' || !radioRef.current.contains(target)) return;
    const idx = [...target?.parentElement?.childNodes].indexOf(target);
    setSelected(idx);
    if (onChange) {
      onChange(items[idx]);
    }
  }, [items, onChange, setSelected]);
  (0, _base.useEventListener)('mousedown', optionSelectionHandler);
  const pillItems = items.map((item, ix) => {
    const isSelected = selected === ix;
    return /*#__PURE__*/_react.default.createElement(_pillSelectionItem.default, (0, _extends2.default)({
      key: `${ariaLabel}-${ix}`,
      "data-cy": "pill-selection"
    }, item, {
      icon: (0, _precheckIcons.getIcon)(isSelected),
      selected: isSelected,
      a11yAttributes: {
        ['aria-setsize']: items.length,
        ['aria-posinset']: ix + 1,
        ['aria-selected']: isSelected,
        tabIndex: '0',
        role: 'radio'
      }
    }));
  });
  return /*#__PURE__*/_react.default.createElement(PillSelectionContainer, {
    id: `id-${id}`,
    split: split,
    ref: radioRef,
    "data-partial": partial
  }, pillItems);
}
PillSelection.propTypes = {
  id: _propTypes.default.string,
  items: _propTypes.default.array,
  ariaLabel: _propTypes.default.string,
  split: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  selected: _propTypes.default.number,
  setSelected: _propTypes.default.func,
  partial: _propTypes.default.string
};